import React from 'react';
import { Col, Panel,  FormGroup, Row,Button } from 'react-bootstrap'
import ContentWrapper from '../../components/layout/ContentWrapper'
import { userroles,orange,videoblue,warning,green } from '../../utils/constants'
import { positivenumbers } from '../../utils/functions/positivenumbers'
import { searchUser, sendUserInvitation } from './Logic/user'
import { Labels,Messages } from './constants'

class NewUser extends React.Component {

		constructor(props) {
      super(props);
			this.handleSearchUser = this.handleSearchUser.bind(this);
			this.state = {
				suffix:'',
				prefix:'',
				foundmember:false,
				searchmode: false,
				user:null,
				userrole:userroles.Director,
				searching:false,
				sendinginvite:false,
				invitesent:false,
				userName:''
			}
			this.handleSearchUser = this.handleSearchUser.bind(this)
			this.handleMemberIDChange = this.handleMemberIDChange.bind(this)
			this.handleSendInvitation = this.handleSendInvitation.bind(this)
			this.handleRoleChange     = this.handleRoleChange.bind(this)
    }
	handleSearchUser()
		{
			const { prefix,suffix } = this.state
			this.setState({ searching:true })
			const _this = this
			searchUser(prefix,suffix).then(function(response) {
				const { data } = response
				const user = data.value
				const foundmember = user != null
				_this.setState({ foundmember,searchmode:true,user,searching:false,userName:user.firstName + ' ' + user.lastName })
			})
			.catch(function () {
				_this.setState({ foundmember:false,searchmode:true,user:null,searching:false })
			})
    }
    handleMemberIDChange(evt)
    {
			const { id,value } = evt.target		
			const reset = { 
				searchmode:false,
				user:null,
				userName:'',
				invitesent:false
			}	

			if(id == 'prefix')
			{
				this.setState({ prefix:value,...reset })
			}
			else
			{
				this.setState({ suffix:value,...reset })
			}
    }
		handleSendInvitation() {
      const { user, userrole, prefix, suffix } = this.state;
      const { emailAddress, firstName, lastName } = user;
      this.setState({ sendinginvite: true, invitesent: false });
      const _this = this;
      
			const reset = { 
				sendinginvite:false,
				invitesent:true,
				searchmode:false,
				user:null,
				prefix:'',
				suffix:''  
			}
      console.log('Userinvitation userrole', userrole);
      sendUserInvitation(emailAddress, userrole, firstName, lastName, `${prefix}-${suffix}`).then(function() {
          _this.setState(reset);
        })
        .catch(function(error) {
          console.log('handleSendInvitation error message', error);
          _this.setState(reset);
        });
    }
		handleRoleChange(evt)
		{
			const userrole = evt.target.value
			this.setState({ userrole })
		}
		render() 
		{   
			const { 
				prefix,suffix,foundmember ,searchmode,user,searching,sendinginvite,invitesent ,userName
			} = this.state
			const btnInviteLabel = sendinginvite ? Labels.sendingInvitation : Labels.sendInvite 
			const missingEmail   = (user != null) && (user.emailAddress == '') ? true:false

			return (
				<ContentWrapper>
					<Row>
						<Col sm={8}>
							<Panel>
								<h5><i className="fa fa-user" aria-hidden="true" />&nbsp;&nbsp;User Details</h5>
								<form className="form-horizontal">
								<FormGroup>
									<Col sm={ 3 }  smOffset={2}>
										<input className="form-control" value={prefix} placeholder='Member ID Prefix' id='prefix' type='text' onKeyPress={positivenumbers} onChange={this.handleMemberIDChange} text={prefix}  style={{ marginRight:'0',borderRadius:'0',minWidth:'150px' }}/>
									</Col>
									<Col sm={ 1 } style={{ marginLeft:'-20px',paddingTop:'7px' }}>
										<span>-</span>
									</Col>
									<Col sm={ 3 } style={{ marginLeft:'-7%' }}>
										<input className="form-control" value={suffix} placeholder='Member ID Suffix' id='suffix' type='text'  onKeyPress={positivenumbers} onChange={this.handleMemberIDChange} text={suffix}  style={{ margin:'0' ,minHeight:'35px',borderRadius:'0',width:'100%' }}/>
									</Col>
									<Col lg={1} style={{ marginLeft:'-30px' }}>
										<span className="input-group-btn" lg={1}>
											<Button className="btn btn-default"  style={{ marginLeft:'0',marginTop:'-1px', minHeight:'36px',maxWidth:'41px',color:orange }} onClick={this.handleSearchUser} disabled={prefix == '' || suffix == ''}> <i className={searching == true ? "fa fa-spinner fa-spin":"fa fa-search"} aria-hidden="true"  /></Button>
										</span>
									</Col>
								</FormGroup>
								{
									invitesent && (
									<div>
										<h5 style={{ color:green }}>&nbsp;&nbsp;<i className="fa fa-info-circle" />{' '}{Messages.InvitationSent} {' ' + userName}</h5>
									</div>)
								}
								{
									(searchmode  && !foundmember) &&
									( 
										<div sm={4} >
											<h5 style={{ color:warning, marginLeft:'18%' }}><i className="fa fa-exclamation-triangle" aria-hidden="true"  />&nbsp;ID {prefix}-{suffix} not found</h5>
										</div> 
									)
								}
								{
									user != null && missingEmail  &&
									( 
										<div sm={4} >
											<h5 style={{ color:warning, marginLeft:'18%' }}><i className="fa fa-exclamation-triangle" aria-hidden="true"  />&nbsp;{Messages.EmailMissing}</h5>
										</div> 
									)
								}
								{
									(user != null) && (
									<section>
										<div>
											<FormGroup>
												<label className="col-sm-3 control-label">First Name:</label>
												<Col sm={8 } style={{ paddingTop:'7px',paddingLeft:'0' }}>
													<span style={{ fontWeight:'bold',color:videoblue }}>{ user.firstName } {' '} { user.lastName }</span>
												</Col>
											</FormGroup>
										
											<FormGroup>
												<label className="col-sm-3 control-label">Email:</label>
												<Col sm={ 8 }  style={{ paddingTop:'7px',paddingLeft:'0' }}>
													<span style={{ fontWeight:'bold',color:videoblue }}>{user.emailAddress}</span>
												</Col>
											</FormGroup>
										</div>  
										<hr/>
										<h5><i className="fa fa-cloud" aria-hidden="true"  />&nbsp;&nbsp;Application Access</h5>
										<fieldset>
											<FormGroup>
												<label className="col-sm-2 control-label" />
												<Col sm={ 10 } md={8}>
													<div className="checkbox c-checkbox">
														<label>
															&nbsp;<input type="checkbox" defaultChecked value="" />
															<em className="fa fa-check" />&nbsp;&nbsp;Junior Gold Qualifier Portal
														</label>
													</div>
												</Col>
											</FormGroup>
											<p/>
											<FormGroup>
												<label className="col-sm-2 control-label" />
												<Col sm={ 10 }  md={8}>
													<label className="radio-inline c-radio">
													<input id="rankingec" type="radio" name="role" value={userroles.Director} defaultChecked onChange={this.handleRoleChange} />
															<em className="fa fa-circle" />&nbsp;&nbsp;Event Director</label>
													<label className="radio-inline c-radio">
															<input id="rankingadm" type="radio" name="role" value={userroles.Administrator} onChange={this.handleRoleChange} />
															<em className="fa fa-circle" />&nbsp;&nbsp;Administrator
													</label>  
												</Col>
											</FormGroup>
										</fieldset>
										<hr/>                     
										<FormGroup>
										<Col sm={ 10 }>
											<Button  bsStyle="primary" onClick={this.handleSendInvitation} style={{ fontSize:'110%' }} disabled={invitesent || missingEmail}>
												<i className={sendinginvite ? "fa fa-spinner fa-spin" : "fa fa-envelope-o"} aria-hidden="true" />&nbsp;&nbsp;{ btnInviteLabel }
											</Button>
										</Col>
									</FormGroup>
									</section>		
									)
								}
								</form>
						</Panel>
					</Col>
				</Row>
				</ContentWrapper>
				)
    }
}

export default NewUser




// WEBPACK FOOTER //
// ./src/containers/newuser/index.js